import React from 'react'
import { LazyLoadComponent } from 'react-lazy-load-image-component'
import styled from 'styled-components'
import { Link } from 'gatsby'

import { MysqlCategories } from '../../graphqlTypes'

const Container = styled.li`
  margin: 0 10px 0;
  width: 70px;
  &:first-child {
    margin-left: 0;
  }
  &:last-child {
    position: relative;
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 100%;
      width: 10px;
      height: 100%;
    }
  }
`

const Item = styled(Link)`
  display: block;
  text-decoration: none;
`

const ImageFrame = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.border.main};
  border-radius: 3px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
  margin: 0 auto;
  padding: 4px;
  width: 60px;
  height: 60px;
`

const Image = styled.img`
  object-fit: contain;
  width: 100%;
  height: 100%;
`

const Title = styled.p`
  color: ${({ theme }) => theme.palette.font.dark};
  font-size: 10px;
  font-weight: 600;
  margin: 4px 0 0;
  text-align: center;
`

type Props = {
  category: MysqlCategories
  to: string
}

export default function ItemCard({ category, to }: Props) {
  return (
    <Container>
      <Item to={to}>
        <ImageFrame>
          <LazyLoadComponent>
            <Image alt={`${category.title}部門 受賞商品`} src={`${category.fields!.imageUrl}?auto=format`} />
          </LazyLoadComponent>
        </ImageFrame>
        <Title>{category.title}</Title>
      </Item>
    </Container>
  )
}
